export default __webpack_public_path__ + "static/media/gupsu_stop.61789eff.svg";